import { bootstrap } from './game/bootstrap';

bootstrap().catch((err) => {
  console.error('[twin-suns-turbo] fatal init error', err);
  const fallback = document.createElement('div');
  fallback.className = 'tst-overlay';
  fallback.innerHTML = `<div style="text-align:center;color:#ff8888;">
    <div style="font-size:24px;margin-bottom:8px;">Init failed</div>
    <div style="font-size:13px;">${String(err?.message ?? err)}</div>
  </div>`;
  document.body.appendChild(fallback);
});
